<div class="dmsans">
<div class="popup-wraper" *ngIf="isNGO">
  <div class="campainer-img-container">
    <img loading="lazy" class="campainer-img" [attr.data-src]="campaigner?.avtar?.cdn_path || util.defaultImg" [alt]="'Campaigner - ' + campaigner?.full_name">
  </div>
  <div class="appeal">
    <span *ngIf="!vars.showKCart" class="txt">
      {{'Stories.donations.couldUseHelp' | translatePipe | async}} <br/>
      {{'Stories.donations.smallContribution' | translatePipe | async}}
      <app-currency-icon *ngIf="data?.contributeDetails" [currency]="data?.contributeDetails?.selected_currency"></app-currency-icon> {{data?.contributeDetails?.min_donation}}
    </span>
    <span *ngIf="vars.showKCart" class="txt" [innerHTML]="info.extraProductDescription()">
    </span>
  </div>
  <div class="action-btns">
    <button type="button" class="act-btn btn1" mat-button (click)="dialog.closeAll(); cancelPayment.next(true)">{{'Stories.donations.noThanks' | translatePipe | async}}</button>
    <button type="button" class="act-btn btn2" mat-raised-button (click)="dialogRef.close()">{{'Stories.donations.surewillHelp' | translatePipe | async}}</button>
  </div>
</div>

 <div class="popup-wrapper" *ngIf="!isNGO">
   <div class="close-btn">
     <i class="material-icons" (click)="handleCloseAndSendEvent('closeBtn')">close</i>
   </div>
  <div class="top-img-wrapper">
    <img loading="lazy" [attr.data-src]="'/assets/images/donation-confirmation-img.png'" alt="hands image" />
  </div>
  <div class="content">
    <div class="title">
      {{vars.showKCart ? info.extraProductTitle : info.title}}
    </div>
    <div class="description" [innerHTML]="vars.showKCart ? info.extraProductDescription() : !isMedical ? info.non_med_desc(util.capitalizeFirstLatter(beneficiaryName)) : info.description(beneficiaryName, data?.contributeDetails?.min_donation, util.getCurrencyIcon(data?.currency).symbol)">
    </div>
  </div>
  <div class="action-wrapper">
    <app-button label="Yes, I will help" btnClass="full-width" (click)="handleCloseAndSendEvent('help')"></app-button>
    <button mat-button  class="full-width" (click)="handleCloseAndSendEvent('cancel')">
      Sorry, not today
    </button>
  </div>
 </div>
</div>

